import React from "react";
import { Box, Typography } from "@mui/material";
import { NewsletterSubscriptionsTab } from "../components";

export const NewsletterSubscriptions: React.FC = () => (
  <Box sx={{ p: { xs: 2.5, md: 3 } }}>
    <Box mb={3}>
      <Typography variant="h5" fontWeight={600}>
        Newsletter Subscriptions
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        View and export newsletter subscription data.
      </Typography>
    </Box>
    <NewsletterSubscriptionsTab />
  </Box>
);
